import { useTranslation } from 'react-i18next'

import ConditionsEditor from '@/common/components/ConditionsEditor/ConditionsEditor'

import { errorTypes } from '../constants'
import { getConditionTypes } from './helpers'

const PolicyRuleConditionsEditor = ({
  conditions,
  onChange,
  disabled,
  productTypes,
  productCategories,
  productCollections,
  returnReasons,
  regions,
  errors = [],
  currencies,
  storeCurrencyCode,
  disabledConditionFields = [],
}) => {
  const { t, i18n } = useTranslation()
  const conditionTypes = getConditionTypes({
    productTypes,
    productCategories,
    productCollections,
    returnReasons,
    regions,
    language: i18n.language,
    disabledConditionFields,
    t,
  })

  return (
    <ConditionsEditor
      conditions={conditions}
      onChange={onChange}
      disabled={disabled}
      errors={errors}
      title="Condiciones"
      description="Define el conjunto de condiciones que deben cumplirse para activar la acción descrita anteriormente."
      emptyMessage="Se requiere al menos una condición para que la regla tenga efecto."
      conditionTypes={conditionTypes}
      errorType={errorTypes.conditionIncomplete}
      currencies={currencies}
      storeCurrencyCode={storeCurrencyCode}
    />
  )
}

export default PolicyRuleConditionsEditor
